import React, { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { PickList } from 'primereact/picklist';
import { getConstant } from '../../../../utils/constants';
import { get } from 'underscore';

function MainProjectPage({ isActive }) {
  const [orderedProjectList, setOrderedProjectList] = useState([]);
  const [nonOrderedProjectList, setNonOrderedProjectList] = useState([]);
  const { navigationContext } = useNavigationContext();
  const { accountContext } = useAccountContext();

  useEffect(() => {
    fetchOrderedProjectList();
    fetchNonOrderedProjectList();
  }, [navigationContext]);

  const fetchOrderedProjectList = async () => {
    await privateFetch(
      'GET',
      'chiennoir',
      `/cu/${accountContext.id}/project/highlight/?ordered=true`
    ).then((res) => {
      setOrderedProjectList(res);
    });
  };

  const fetchNonOrderedProjectList = async () => {
    await privateFetch(
      'GET',
      'chiennoir',
      `/cu/${accountContext.id}/project/highlight/?ordered=false`
    ).then((res) => {
      setNonOrderedProjectList(res);
    });
  };

  const onChange = (e) => {
    handleOrderChange(e.target);
    handleRemoveOrder(e.source);
  };

  const handleOrderChange = async (projects) => {
    const payload = projects.map((p, index) => ({
      ...p,
      order: index + 1
    }));
    await privateFetch(
      'PUT',
      'chiennoir',
      `/cu/${accountContext.id}/project/highlight/`,
      null,
      JSON.stringify(payload)
    ).then(() => {
      fetchOrderedProjectList();
      fetchNonOrderedProjectList();
    });
  };

  const handleRemoveOrder = async (projects) => {
    const payload = projects.map((p) => ({
      ...p,
      order: 0
    }));
    await privateFetch(
      'PUT',
      'chiennoir',
      `/cu/${accountContext.id}/project/highlight/`,
      null,
      JSON.stringify(payload)
    ).then(() => {
      fetchOrderedProjectList();
      fetchNonOrderedProjectList();
    });
  };

  const itemTemplate = (p) => (
    <div className="flex w-full items-center gap-x-3 p-3 justify-between ">
      <div className="flex items-center gap-x-3">
        {p.order !== 0 && (
          <span className="font-bold h-full flex justify-center items-center mr-2 ">{p.order}</span>
        )}
        <img
          src={p.main_image.file}
          className="h-24 w-24 object-cover shadow-md block rounded-md"
          alt="choix de l'illustation"
        />
        <div className="flex flex-col gap-y-1">
          <div className="text-xl font-bold  ">{p.title}</div>
          <span className="font-medium ">{p.year}</span>

          <span className="font-small">
            {p.localisation.country}, {p.localisation.city}
          </span>
        </div>
      </div>

      {p.order !== 0 && (
        <div className="flex flex-row gap-x-2">
          <div
            className="w-10 h-10 rounded-full"
            style={{
              backgroundColor: getConstant('chiennoir.colors', p.order).mainTextColor
            }}></div>
          <span
            className="w-10 h-10 rounded-full"
            style={{
              backgroundColor: getConstant('chiennoir.colors', p.order).backgroundColor
            }}></span>
        </div>
      )}
    </div>
  );
  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper label="Projets à la une">
        <PickList
          dataKey="id"
          source={nonOrderedProjectList}
          target={orderedProjectList}
          onChange={onChange}
          itemTemplate={itemTemplate}
          breakpoint="1000px"
          sourceHeader="Projets valides"
          targetHeader="Projets à la une"
          sourceStyle={{ height: 'fit-content', minHeight: '500px' }}
          targetStyle={{ height: 'fit-content', minHeight: '500px' }}
        />
      </PageWrapper>
    </div>
  );
}

export default MainProjectPage;
